// eslint-disable-next-line import/prefer-default-export
export const USER_PAGINATION_LIMIT = 5
